import axios from "axios";

export const getAllWarehouseInventoryDispatch = (
  page,
  id,
  store,
  status,
  startDate,
  endDate,
  obj
) => {
  let url = `${process.env.REACT_APP_NOT_SECRET_CODE}/multi-store/get-warehouseInventoryDispatch?per_page=${page}&id=${id}&status=${status}&start_date=${startDate}&end_date=${endDate}&store_id=${store}`;
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const getAllStoresByCountryCode = (countryCode, obj) => {
  return axios
    .get(
      `${process.env.REACT_APP_NOT_SECRET_CODE}/pharmacies?country=${countryCode}`,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      }
    )
    .then((res) => {
      return res.data;
    });
};

export const searchMedicationForWID = (title, obj) => {
  let url = `${process.env.REACT_APP_NOT_SECRET_CODE}/medications?search_medication=${title}&records_per_page=100000000&country=1`;

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const AddWarehouseInventoryDispatchAPI = (Body, obj) => {
  const url = `${process.env.REACT_APP_NOT_SECRET_CODE}/multi-store/create-warehouseInventoryDispatch`;
  return axios
    .post(
      url,
      Body,

      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => err);
};

export const getWarehouseInventoryDispatchById = (id, obj) => {
  let url = `${process.env.REACT_APP_NOT_SECRET_CODE}/multi-store/get-warehouseInventoryDispatch/${id}`;

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const EditWarehouseInventoryDispatchAPI = (Body, id, obj) => {
  console.log(Body);
  const url = `${process.env.REACT_APP_NOT_SECRET_CODE}/multi-store/update-warehouseInventoryDispatch/${id}`;
  return axios
    .put(
      url,
      Body,

      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => err);
};

export const deleteWarehouseInventoryDispatchById = (id, obj) => {
  let url = `${process.env.REACT_APP_NOT_SECRET_CODE}/multi-store/delete-warehouseInventoryDispatch/${id}`;

  return axios
    .delete(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const UpdateWarehouseInventoryDispatchStatus = (Body, obj) => {
  console.log(Body);
  const url = `${process.env.REACT_APP_NOT_SECRET_CODE}/multi-store/update-warehouseInventoryDispatchStatus`;
  return axios
    .post(
      url,
      Body,

      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => err);
};

export const getRiderDetail = (obj) => {
  return axios
    .get(`${process.env.REACT_APP_NOT_SECRET_CODE}/users?role=5`, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};
